import React from 'react';
import './index.css';

const MajorFractionChart = () => (
    <table className="table">
        <thead>
            <tr>
              <th colSpan="2">Major Fraction Chart</th>             
            </tr>
        </thead>
        <tbody>
				<tr className="active">
							<td>Ratio</td>
							<td>Entries needed to advance one additional athlete</td>						
					</tr>
					<tr className="success">
							<td>1:4</td>
							<td>7</td>
					</tr>
					<tr className="info">
							<td>1:5</td>
							<td>8</td>	
					</tr>
					<tr className="warning">
							<td>1:6</td>
							<td>10</td>			
					</tr>
					<tr className="danger">
							<td>1:7</td>
							<td>11</td>
					</tr>
					<tr className="success">
							<td>1:8</td>
							<td>13</td>
					</tr>
					<tr className="info">
							<td>1:9</td>
							<td>14</td>	
					</tr>
					<tr className="warning">
							<td>1:10</td>
							<td>16</td>			
					</tr>
				
        </tbody>
    </table>
 );

 export default MajorFractionChart;
    




// WEBPACK FOOTER //
// ./src/containers/event/components/setup/majorfractionchart.js